import axios from "../axios";

export function checkCompanyIsNotTaken({ company, email, envDomain }) {
    return axios.post(`check`, { company, email, envDomain }).then(({ data }) => data);
}
